export class EntiteBody {
  constructor(
    public readonly libelle: string,
    public readonly interne: boolean,
    public readonly actif: boolean,
    public readonly referent?: string,
    public readonly email?: string,
    public readonly telephone?: string) {
  }
}
